import {useEffect} from 'react'
import {useRelayCachePreheatContext} from '../contexts/RelayCachePreheatContext'
import type {ConcreteRequest, GraphQLTaggedNode} from 'relay-runtime'
import {isFeatureEnabled} from '@github-ui/feature-flags'
import {isLoggedIn} from '@github-ui/client-env'

type UseCachePreheatQueryProps = {
  query?: GraphQLTaggedNode
  variables: Record<string, unknown>
  source: string
  enabled?: boolean
  excludeFromCacheKey?: string[]
  highPriority?: boolean
}

type useCachePreheatQueriesProps = {
  queries: UseCachePreheatQueryProps[]
}

export function useCachePreheatQuery({
  query,
  variables,
  source,
  enabled = true,
  excludeFromCacheKey,
  highPriority,
}: UseCachePreheatQueryProps) {
  const {markQueryForPreheating} = useRelayCachePreheatContext()

  const preHeatingEnabled = isFeatureEnabled('issues_preheating_main') && isLoggedIn()

  useEffect(() => {
    if (!enabled || !query || !preHeatingEnabled) {
      return
    }
    markQueryForPreheating(query as ConcreteRequest, variables, source, excludeFromCacheKey, highPriority)
  }, [markQueryForPreheating, variables, query, source, enabled, excludeFromCacheKey, highPriority, preHeatingEnabled])
}

export function useCachePreheatQueries({queries}: useCachePreheatQueriesProps) {
  const {markQueryForPreheating} = useRelayCachePreheatContext()

  const preHeatingEnabled = isFeatureEnabled('issues_preheating_main') && isLoggedIn()

  useEffect(() => {
    for (const query of queries) {
      const enabled = query.enabled ?? true
      if (!enabled || !query.query || !preHeatingEnabled) {
        continue
      }
      markQueryForPreheating(
        query.query as ConcreteRequest,
        query.variables,
        query.source,
        query.excludeFromCacheKey,
        query.highPriority,
      )
    }
  }, [markQueryForPreheating, queries, preHeatingEnabled])
}
